<div id="homepage-6">
  <app-home-banner></app-home-banner>
  <app-home-features></app-home-features>
  <app-home-promotions></app-home-promotions>
</div>
